// removed by extract-text-webpack-plugin
module.exports = {"UserInput":"UserInput--3lWTN"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Search/EntitySearch.scss
// module id = 949
// module chunks = 1